import React from "react";
import { FaPlane } from "react-icons/fa";
import "./SearchResultsFlightMark.css";

/** Orange HotelsRiver plane on a dashed track. Loops while a search is active. */
export default function SearchResultsFlightMark({
  caption = "מחפשים עבורכם...",
}) {
  return (
    <div className="hotel-search-flight">
      <p className="hotel-search-flight__caption">{caption}</p>
      <div className="hotel-search-flight__track">
        <span className="hotel-search-flight__dash" />
        <FaPlane className="hotel-search-flight__plane" aria-hidden="true" />
      </div>
    </div>
  );
}
